import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import {
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaDirections,
} from "react-icons/fa";
import { GiMedicalPack } from "react-icons/gi";
import {
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";

import tambaramskin from "./../../../../assets/images/tambaramskinicon.png";
import tambaramhair from "./../../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "./../../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "./../../../../assets/images/tambarambanner4.png";

import img1 from "./../../../../assets/images/autoscroll1.jpg";
import img2 from "./../../../../assets/images/autoscroll2.jpg";
import img3 from "./../../../../assets/images/autoscroll3.jpg";
import img4 from "./../../../../assets/images/autoscroll4.jpg";
import img5 from "./../../../../assets/images/autoscroll5.jpg";
import img6 from "./../../../../assets/images/autoscroll6.jpg";
import img7 from "./../../../../assets/images/autoscroll7.jpg";
import img8 from "./../../../../assets/images/autoscroll8.jpg";
import img9 from "./../../../../assets/images/autoscroll9.jpg";
import img10 from "./../../../../assets/images/autoscroll10.jpg";
import img11 from "./../../../../assets/images/autoscrollskin1.png";
import img12 from "./../../../../assets/images/autoscrollskin2.png";
import img13 from "./../../../../assets/images/autoscrollskin3.png";
import img14 from "./../../../../assets/images/autoscrollskin4.png";
import img15 from "./../../../../assets/images/autoscrollskin5.png";
import img16 from "./../../../../assets/images/autoscrollskin6.png";
import img17 from "./../../../../assets/images/autoscrollskin7.png";
import img18 from "./../../../../assets/images/autoscrollskin8.png";
import img19 from "./../../../../assets/images/autoscrollskin9.png";
import img20 from "./../../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "./../../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "./../../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "./../../../../assets/images/chennaitambaramhomeopathy.png";
import chennaitambaramskin1 from "./../../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "./../../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambarampcos from "./../../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "./../../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "./../../../../assets/images/chennaitambarammentalhealth.jpg";

import chennaivalasaravakkamhair from "./../../../../assets/images/chennaivalasaravakkamhair1.jpg";
import chennaivalasaravakkamhair1 from "./../../../../assets/images/chennaivalasaravakkamhair2.jpg";
import chennaivalasaravakkamhair2 from "./../../../../assets/images/chennaivalasaravakkamhair3.jpg";
import chennaivalasaravakkamhair3 from "./../../../../assets/images/chennaivalasaravakkamhair4.jpg";
import chennaivalasaravakkamdental1 from "./../../../../assets/images/chennaivalasaravakkamdental1.jpg";
import chennaivalasaravakkamdental2 from "./../../../../assets/images/chennaivalasaravakkamdental4.jpg";
import chennaivalasaravakkamdental3 from "./../../../../assets/images/chennaivalasaravakkamdental5.jpg";

import hcuraHeroVideo from "./../../../../assets/video/hcura-hero2.mp4";
import hcuraHeroVideo1 from "./../../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "./../../../../assets/video/hcura-hero4.mp4";

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const Kodambakkam = () => {
  const [activeLocation, setActiveLocation] = useState("kodambakkam");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  const [valasaravakamchennaiBaModalOpen, setTambaramBaModalOpen] = useState(false);
  const [valasaravakamchennaiBaModalItems, setTambaramBaModalItems] = useState([]);
  const [valasaravakamchennaiBaModalStartIndex, setTambaramBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (valasaravakamchennaiBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft =
          valasaravakamchennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [valasaravakamchennaiBaModalOpen, valasaravakamchennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  useEffect(() => {
    document.title = "H-Cura | Best Hair, Skin, Dental & Homeopathy Clinic in Kodambakkam, Chennai";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Advanced hair, skin, dental & homeopathy treatments in Kodambakkam, Chennai. Book appointment at H-Cura Multispecialty Clinic for expert care and visible results."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "H-Cura Multispecialty Clinic Kodambakkam, Best multispecialty clinic in Kodambakkam, Hair fall treatment in Kodambakkam, PRP hair treatment in Kodambakkam, Skin clinic in Kodambakkam, Best dermatologist in Kodambakkam, Dental clinic in Kodambakkam, Homeopathy clinic in Kodambakkam, PCOS treatment in Kodambakkam, Clinic near Vadapalani"
      );
    }
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-kodambakkam-chennai");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-kodambakkam-chennai");
      document.head.appendChild(canonicalLink);
    }
  }, []);
  useEffect(() => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });
}, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    kodambakkam: {
      name: "KODAMBAKKAM",
      address: "No.193, (301), NSK salai, Arcot road, Metro pillar no.4 opposite, Kodambakkam, Chennai - 600024.",
      phone: "+91 99646 88333",
      hours: "All day 10 am to 8pm",
      nearbyAreas: "Vadapalani, Ashok Nagar, T Nagar, Nungambakkam, Arcot Road",
      popularServices: [
        "PRP Hair Treatment",
        "HydraFacial & Skin Glow",
        "Invisible Braces",
        "PCOS Homeopathy Care",
      ],
      specialties: "Hair, Skin, Dental & Homeopathy",
      mapUrl: "https://share.google/pqMBpL5CNYLFubQly",
      video: hcuraHeroVideo1,
    }
  };

  const advancedServices = [
    {
      id: "hair",
      title: "Hair Treatments in Kodambakkam – Restore Stronger, Healthier Hair",
      subtitle: "Stop Hair Loss. Stimulate Natural Hair Growth.",
      description:
        "Restore stronger and healthier hair with advanced hair treatments in Kodambakkam. Our specialists provide PRP Hair Treatment, GFC Therapy, QR678 Hair Treatment, and customized scalp care solutions to reduce hair fall and promote natural regrowth.",
      image: chennaitambarm,
      treatments: [
        {
          name: "PRP Hair Treatment Kodambakkam",
          description: "Boost natural hair regrowth using PRP hair treatment. We use growth factors from your own blood to strengthen hair roots.",
          icon: "prp-icon",
          image: chennaivalasaravakkamhair,
          benefits: ["Natural hair regrowth", "Strengthens follicles", "No surgery", "Quick recovery"],
        },
        {
          name: "GFC Therapy Kodambakkam",
          description: "Advanced growth factor concentrate therapy for faster and thicker hair growth using specialized medical protocols.",
          icon: "gfc-icon",
          image: chennaivalasaravakkamhair1,
          benefits: ["Faster hair growth", "Increased hair density", "Natural appearance", "Personalized care"],
        },
        {
          name: "QR678 Hair Treatment",
          description: "Plant-based advanced hair regrowth therapy that stimulates hair follicles for effective hair fall control.",
          icon: "laser-therapy-icon",
          image: chennaivalasaravakkamhair2,
          benefits: ["Non-surgical solution", "Natural extracts", "Proven results", "Enhanced scalp absorption"],
        },
      ],
      testimonial: {
        quote: "My hair fall reduced significantly after PRP treatment at H-Cura Kodambakkam. Highly recommended.",
        author: "Priya R.",
        location: "Vadapalani",
      },
    },
    {
      id: "skin",
      title: "Skin Treatments in Kodambakkam – Clear Skin. Healthy Glow.",
      subtitle: "Treat Skin Concerns. Reveal a Younger Glow.",
      description:
        "Achieve healthy and radiant skin with our advanced skin treatments in Kodambakkam. We treat acne, pigmentation, dark spots, wrinkles, melasma, scars, and uneven skin tone using safe and effective technologies.",
      image: chennaitambarmskin,
      treatments: [
        {
          name: "HydraFacial Kodambakkam",
          description: "Deep skin cleansing and glow-enhancing facial treatment that removes dead skin and makes your face glow immediately.",
          icon: "hydrafacial-icon",
          image: chennaitambaramskin1,
          benefits: ["Deep cleansing", "Instant glow", "Hydrated skin", "No downtime"],
        },
        {
          name: "Laser Skin Treatments",
          description: "Safe laser treatments to remove dark spots, acne marks, and achieve an even skin tone with long-lasting results.",
          icon: "pigmentation-icon",
          image: chennaitambaramskin2,
          benefits: ["Reduces pigmentation", "Evens skin tone", "Smooth texture", "Safe procedures"],
        },
        {
          name: "Anti-Aging Solutions",
          description: "Advanced clinical procedures to reduce wrinkles and tighten skin for a youthful, natural appearance.",
          icon: "antiaging-icon",
          image: chennaivalasaravakkamhair3,
          benefits: ["Reduces wrinkles", "Tightens skin", "Boosts collagen", "Natural glow"],
        },
      ],
      testimonial: {
        quote: "Best skin clinic in Kodambakkam. My acne and pigmentation improved visibly.",
        author: "Karthik M.",
        location: "T Nagar",
      },
    },
    {
      id: "dental",
      title: "Dental Clinic in Kodambakkam – Healthy Teeth. Confident Smile.",
      subtitle: "Treat Dental Issues. Achieve a Beautiful Smile.",
      description:
        "Our dental clinic in Kodambakkam offers teeth cleaning, root canal treatment, smile correction, invisible braces, teeth whitening, and cosmetic dentistry.",
      image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      treatments: [
        {
          name: "Invisible Braces Kodambakkam",
          description: "Straighten your teeth comfortably with clear and removable invisible braces for a perfect smile enhancement.",
          icon: "aligner-icon",
          image: chennaivalasaravakkamdental1,
          benefits: ["Nearly invisible", "Comfortable wear", "Removable", "Fewer visits"],
        },
        {
          name: "Root Canal Treatment",
          description: "Painless and effective root canal procedures to save damaged teeth and restore oral health using modern technology.",
          icon: "rootcanal-icon",
          image: chennaivalasaravakkamdental2,
          benefits: ["Pain-free procedure", "Preserves natural tooth", "Quick recovery", "Expert dentists"],
        },
        {
          name: "Teeth Whitening",
          description: "Professional whitening treatments to remove stains and brighten your smile in a single clinical visit.",
          icon: "smile-icon",
          image: chennaivalasaravakkamdental3,
          benefits: ["Instant results", "Safe for enamel", "Removes stains", "Boosts confidence"],
        },
      ],
      testimonial: {
        quote: "Excellent dental care and invisible braces treatment.",
        author: "Shalini P.",
        location: "Ashok Nagar",
      },
    },
    {
      id: "homeopathy",
      title: "Homeopathy in Kodambakkam – Natural Healing for Complete Wellness",
      subtitle: "Safe, Natural Medicine for Better Health.",
      description:
        "H-Cura provides safe and personalized homeopathy treatments in Kodambakkam for PCOS, thyroid issues, diabetes, stress, and hormonal imbalance.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "PCOS Treatment Kodambakkam",
          description: "Natural homeopathy-based PCOS treatment to regulate hormones and improve overall reproductive health safely.",
          icon: "hormonal-icon",
          image: chennaitambarampcos,
          benefits: ["Hormone balance", "Regular periods", "Weight management", "Personalized care"],
        },
        {
          name: "Chronic Disease Care",
          description: "Holistic treatment for long-term health concerns like diabetes and joint pain using natural homeopathic remedies.",
          icon: "chronic-icon",
          image: chennaitambaramchronic,
          benefits: ["Treats root cause", "Safe for all ages", "No side effects", "Long-term wellness"],
        },
        {
          name: "Mental Health Wellness",
          description: "Gentle and effective treatments for stress, anxiety, and sleep disorders to improve your quality of life naturally.",
          icon: "constitutional-icon",
          image: chennaitambarammentalhealth,
          benefits: ["Reduces anxiety", "Better sleep", "Natural mood boost", "Safe approach"],
        },
      ],
      testimonial: {
        quote: "Natural PCOS treatment helped regulate my periods and improve my health.",
        author: "Divya S.",
        location: "Kodambakkam",
      },
    },
  ];

  const testimonials = [
    {
      name: "Priya R.",
      location: "Vadapalani",
      text: "My hair fall reduced significantly after PRP treatment at H-Cura Kodambakkam. Highly recommended.",
      rating: 5,
      service: "Hair Treatment",
    },
    {
      name: "Karthik M.",
      location: "T Nagar",
      text: "Best skin clinic in Kodambakkam. My acne and pigmentation improved visibly.",
      rating: 5,
      service: "Skin Care",
    },
    {
      name: "Shalini P.",
      location: "Ashok Nagar",
      text: "Excellent dental care and invisible braces treatment.",
      rating: 5,
      service: "Dental Care",
    },
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Prime Location",
      description: "Conveniently located in Kodambakkam, our clinic is easily accessible from Vadapalani, Arcot Road, T Nagar, Nungambakkam, and Ashok Nagar.",
      highlight: "Good Location",
    },
    {
      icon: <FaUserMd />,
      title: "Expert Specialists",
      description: "Our team of experienced doctors specializes in Hair Treatment, Skin Care, Dental Solutions, and Homeopathy.",
      highlight: "Expert Care",
    },
    {
      icon: <GiMedicalPack />,
      title: "Advanced Technology",
      description: "We use advanced medical equipment and proven clinical techniques for PRP, Laser Skin Treatment, and Digital Dentistry.",
      highlight: "Modern Equipment",
    },
    {
      icon: <FaHeartbeat />,
      title: "Women’s Health",
      description: "Specialized expertise in PCOS/PCOD treatment and women’s health care using safe, natural homeopathic remedies.",
      highlight: "Complete Care",
    },
    {
      icon: <FaAward />,
      title: "Proven Results",
      description: "Hundreds of satisfied patients from Kodambakkam trust us for effective treatments that deliver visible results.",
      highlight: "Happy Patients",
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personalized Care",
      description: "Every treatment plan is customized based on individual patient condition, diagnosis, and long-term goals.",
      highlight: "Individual Treatment",
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Safety Standards",
      description: "Strict hygiene protocols, sterilized equipment, and international safety standards ensure complete patient safety.",
      highlight: "Safe Treatment",
    },
    {
      icon: <MdSupportAgent />,
      title: "Continuous Support",
      description: "Regular follow-ups and patient guidance throughout your journey to ensure optimal and lasting results.",
      highlight: "Ongoing Support",
    },
  ];

  const testimonialQuotes = [
    "The doctors here really listen to your problems and make treatment plans that work.",
    "After trying many places, only H-Cura could solve my skin problems completely.",
    "Excellent dental care and invisible braces treatment.",
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair": return "/advanced-grow-hair-treatment";
      case "skin": return "/advanced-hydrafacial-treatment";
      case "dental": return "/dental-treatment";
      case "homeopathy": return "/homeopathy-best-treatments/";
      default: return "/services";
    }
  };

  const servicesBackgroundUrl = "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

  const serviceIconMap = {
    hair: { url: tambaramhair, bgColor: "rgba(255,154,158,0.12)", borderColor: "rgba(255,154,158,0.18)", color: "#ff4d6d" },
    skin: { url: tambaramskin, bgColor: "rgba(255,223,121,0.12)", borderColor: "rgba(255,223,121,0.18)", color: "#ffb400" },
    dental: { url: "https://img.icons8.com/fluency/48/000000/tooth.png", bgColor: "rgba(144,238,144,0.12)", borderColor: "rgba(144,238,144,0.18)", color: "#28a745" },
    homeopathy: { url: tambaramleaf, bgColor: "rgba(135,206,250,0.12)", borderColor: "rgba(135,206,250,0.18)", color: "#0099cc" },
  };

  const treatmentIconMap = {
    "prp-icon": { url: "https://img.icons8.com/fluency/48/000000/syringe.png", bgColor: "rgba(255,140,140,0.06)", borderColor: "rgba(255,140,140,0.12)" },
    "gfc-icon": { url: "https://img.icons8.com/fluency/48/000000/biotech.png", bgColor: "rgba(170,200,255,0.06)", borderColor: "rgba(110,160,255,0.12)" },
    "hydrafacial-icon": { url: "https://img.icons8.com/fluency/48/000000/spa-care.png", bgColor: "rgba(200,255,230,0.06)", borderColor: "rgba(60,200,120,0.12)" },
    "antiaging-icon": { url: "https://img.icons8.com/fluency/48/000000/collagen.png", bgColor: "rgba(220,245,255,0.06)", borderColor: "rgba(80,200,240,0.12)" },
    "pigmentation-icon": { url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png", bgColor: "rgba(250,210,255,0.06)", borderColor: "rgba(220,120,240,0.12)" },
    "aligner-icon": { url: "https://img.icons8.com/fluency/48/000000/braces.png", bgColor: "rgba(230,230,255,0.06)", borderColor: "rgba(140,120,240,0.12)" },
    "smile-icon": { url: "https://img.icons8.com/fluency/48/000000/happy-tooth.png", bgColor: "rgba(200,255,220,0.06)", borderColor: "rgba(80,200,120,0.12)" },
    "rootcanal-icon": { url: "https://img.icons8.com/fluency/48/000000/tooth-cleaning.png", bgColor: "rgba(255,240,200,0.06)", borderColor: "rgba(240,180,60,0.12)" },
    "hormonal-icon": { url: "https://img.icons8.com/fluency/48/000000/hormone.png", bgColor: "rgba(255,230,240,0.06)", borderColor: "rgba(240,160,200,0.12)" },
    "chronic-icon": { url: "https://img.icons8.com/fluency/48/000000/medical-pack.png", bgColor: "rgba(230,255,240,0.06)", borderColor: "rgba(160,240,200,0.12)" },
    "constitutional-icon": { url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png", borderColor: "rgba(160,160,240,0.12)" },
  };

  const SAMPLE_GALLERY = {
    hair: [
      { id: "hair-1", combined: img1, testimonial: { quote: "I was completely bald. After 6 months of PRP treatment, my hair came back!", author: "Rajesh K." } },
      { id: "hair-2", combined: img2, testimonial: { quote: "The bald spot on top of my head is now full of hair.", author: "Amit S." } },
      { id: "hair-3", combined: img3, testimonial: { quote: "My hairline was going back. Now it looks like when I was 20!", author: "Priya M." } },
      { id: "hair-4", combined: img4, testimonial: { quote: "GFC and QR678 treatment gave me natural hair regrowth.", author: "Karthik R." } },
      { id: "hair-5", combined: img5, testimonial: { quote: "Best decision I made. My hair grew back naturally.", author: "Deepak V." } },
      { id: "hair-6", combined: img6, testimonial: { quote: "In just 3 months, I could see more hair on my head.", author: "Anitha L." } },
      { id: "hair-7", combined: img7, testimonial: { quote: "From almost bald to full head of hair. Thank you!", author: "Suresh K." } },
      { id: "hair-8", combined: img8, testimonial: { quote: "My wife is shocked seeing my new hair.", author: "Vikram P." } },
      { id: "hair-9", combined: img9, testimonial: { quote: "My thin hair became thick again.", author: "Ramesh B." } },
      { id: "hair-10", combined: img10, testimonial: { quote: "After trying many places, only H-Cura could solve it.", author: "Mahesh T." } },
    ],
    skin: [
      { id: "skin-1", combined: img11, testimonial: { quote: "Had pimples for years. Now my face is completely clear!", author: "Sneha R." } },
      { id: "skin-2", combined: img12, testimonial: { quote: "HydraFacial removed all my dark spots.", author: "Kavya M." } },
      { id: "skin-3", combined: img13, testimonial: { quote: "The lines on my face are almost gone.", author: "Meera K." } },
      { id: "skin-4", combined: img14, testimonial: { quote: "My skin color became even all over.", author: "Preethi S." } },
      { id: "skin-5", combined: img15, testimonial: { quote: "The brown patches on my face disappeared completely.", author: "Divya L." } },
      { id: "skin-6", combined: img16, testimonial: { quote: "People say I look 5 years younger.", author: "Anjali P." } },
      { id: "skin-7", combined: img17, testimonial: { quote: "All my old pimple marks are gone.", author: "Rohit M." } },
      { id: "skin-8", combined: img18, testimonial: { quote: "The dark circles under my eyes are gone.", author: "Lakshmi V." } },
      { id: "skin-9", combined: img19, testimonial: { quote: "My loose skin became tight without surgery.", author: "Sunita K." } },
      { id: "skin-10", combined: img20, testimonial: { quote: "My whole face changed. Everyone asks what treatment I took.", author: "Ravi S." } },
    ],
  };

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = "";
  };

  return (
    <div className="pondyhcura-hcura-chennai">
      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <video autoPlay muted loop playsInline style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -2 }}>
         <source src={hcuraHeroVideo} type="video/mp4" />
        </video>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))', zIndex: -1 }}></div>
        <div className="tambaram-hcura-hero-content-wrapper">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="tambaram-hcura-primary-title">
            H-Cura Multispecialty Clinic in Kodambakkam, Chennai
          </motion.h1>
          <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="tambaram-hcura-secondary-title">
            Advanced Clinical Care for Hair, Skin & Dental Health
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }} className="tambaram-hcura-description-text">
            Looking for the best multispecialty clinic in Kodambakkam, Chennai? H-Cura Multispecialty Clinic offers advanced hair fall treatment, professional skin care, cosmetic and general dental treatments, and expert homeopathy care under experienced doctors. Conveniently located near Vadapalani, Ashok Nagar, T Nagar, Nungambakkam, Arcot Road, and Kodambakkam Railway Station, H-Cura is trusted by patients searching for hair clinic near me, skin specialist in Kodambakkam, dental clinic near me, and homeopathy doctor in Chennai. We focus on personalized treatment plans, visible results, affordable pricing, and long-term wellness — book your appointment today and experience expert healthcare close to home.
          </motion.p>
          <motion.div className="tambaram-hcura-action-buttons" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
            <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
            <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> WhatsApp Consult
            </a>
          </motion.div>
        </div>
      </section>

      <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Real Results. Real Transformations. – H-Cura Kodambakkam</span>
          <h2>Before & After Treatment Photos</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaArrowRight /></span></div>
          <p className="pondyhcura-section-description">
            At H-Cura Multispecialty Clinic in Kodambakkam, we don’t just promise results — we deliver visible transformations. Our Before & After gallery showcases real patients who achieved significant improvement in hair regrowth, acne reduction, pigmentation correction, smile enhancement, and holistic wellness treatments. Patients from Vadapalani, T Nagar, Ashok Nagar, and surrounding Chennai areas trust H-Cura for advanced treatments that create measurable, confidence-boosting results.
          </p>
        </div>
        <div className="pondyhcura-before-tabs">
          {["hair", "skin"].map((s, idx) => (
            <button key={s} className={`pondyhcura-ba-tab ${activeService === idx ? "active" : ""}`} onClick={() => handleServiceChange(idx)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <div className="pondyhcura-before-carousel-wrapper">
          <div className="pondyhcura-before-carousel" role="list">
            {(() => {
              const svcKey = activeService === 0 ? "hair" : "skin";
              const items = SAMPLE_GALLERY[svcKey] || [];
              return items.map((item, idx) => (
                <article key={item.id} className="pondyhcura-ba-clean-card" role="listitem">
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img src={item.combined} alt={`${item.title} at H-Cura Kodambakkam`} className="pondyhcura-ba-clean-image" />
                      <div className="pondyhcura-ba-clean-title"><h4>{item.title}</h4></div>
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button className="pondyhcura-ba-clean-view-btn" onClick={() => openTambaramBaModal(svcKey, idx)}>See More Photos</button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      <section id="why-choose" className="pondyhcura-why-choose-enhanced">
        <div className="pondyhcura-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
        </div>
        <div className="pondyhcura-content-wrapper">
          <motion.div className="pondyhcura-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="pondyhcura-section-subtitle">Best Healthcare</span>
            <h2>Why Choose H-Cura Multispecialty Clinic in Kodambakkam</h2>
            <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaShieldAlt /></span></div>
            <p className="pondyhcura-section-description">
              Choosing the right clinic in Kodambakkam can make the difference between temporary relief and real transformation. At H-Cura, we focus on evidence-based treatments, personalized care, and visible results across Hair Restoration, Skin Treatments, Dental Care, and Homeopathy. Patients from Vadapalani, Arcot Road, T Nagar, Nungambakkam, and Ashok Nagar choose H-Cura because we combine advanced technology with ethical medical practice and transparent consultation.
            </p>
          </motion.div>
          <motion.div className="pondyhcura-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="pondyhcura-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="pondyhcura-feature-header">
                  <div className="pondyhcura-icon-container">{feature.icon}<div className="pondyhcura-icon-glow"></div></div>
                  <span className="pondyhcura-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
          <div className="pondyhcura-cta-container">
            <h3>Experience the H-Cura Kodambakkam Difference</h3>
            <p>Join hundreds of satisfied patients who have transformed their lives with our expert care in Kodambakkam.</p>
            <Link to="/bookconsultation" className="pondyhcura-cta-button">Book Your Visit</Link>
          </div>
        </div>
      </section>

      <section id="services" className="pondyhcura-services-premium-section" ref={sectionRef}>
        <div className={`pondyhcura-services-background ${isVisible ? "visible" : ""}`} style={{ backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed", opacity: isVisible ? 1 : 0 }}></div>
        <div className="pondyhcura-services-container">
          <div className={`pondyhcura-services-header ${isVisible ? "visible" : ""}`}>
            <span className="pondyhcura-services-subtitle">Best Healthcare</span>
            <h2>Our Services at H-Cura Kodambakkam</h2>
            <p className="pondyhcura-services-description">Experience advanced treatments delivered with precision and care in Kodambakkam. Our comprehensive range of services combines modern medical technology with natural healing approaches.</p>
          </div>
          <div className={`pondyhcura-services-tabs ${isVisible ? "visible" : ""}`}>
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button key={service.id} className={`pondyhcura-service-tab ${isActive ? "active" : ""}`} onClick={() => handleServiceChange(index)}>
                  <span className={`pondyhcura-tab-icon bright-icon`} style={{ backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: sIcon?.bgColor, borderRadius: "12px", width: "44px", height: "44px", display: "inline-block" }}></span>
                  <span className="pondyhcura-tab-text">{service.id.charAt(0).toUpperCase() + service.id.slice(1)}</span>
                </button>
              );
            })}
          </div>
          <div className={`pondyhcura-service-content-wrapper ${isVisible ? "visible" : ""}`}>
            <div className={`pondyhcura-service-main-content ${isChanging ? "changing" : ""}`}>
              <div className="pondyhcura-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>
                <div className="pondyhcura-service-cta">
                  <Link to="/bookconsultation" className="pondyhcura-service-btn">Meet Doctor</Link>
                </div>
              </div>
              <div className="pondyhcura-service-image-container">
                <img src={advancedServices[activeService].image} alt={advancedServices[activeService].title} className="pondyhcura-service-main-image" />
              </div>
            </div>
            <div className="pondyhcura-service-treatments">
              <h4>Special Treatments</h4>
              <div className="pondyhcura-treatments-slider">
                {advancedServices[activeService].treatments.map((treatment, tIndex) => {
                  const tIcon = treatmentIconMap[treatment.icon] || null;
                  return (
                    <div className="pondyhcura-treatment-card" key={tIndex}>
                      <div className="pondyhcura-treatment-image"><img src={treatment.image} alt={treatment.name} /></div>
                      <div className="pondyhcura-treatment-content">
                        <div className="pondyhcura-treatment-icon" style={{ backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: tIcon?.bgColor, width: "56px", height: "56px", borderRadius: "12px" }}></div>
                        <h5>{treatment.name}</h5>
                        <p>{treatment.description}</p>
                        <div className="pondyhcura-treatment-benefits">
                          <h6>Benefits:</h6>
                          <ul>{treatment.benefits.map((b, i) => <li key={i}><span className="pondyhcura-benefit-icon">✓</span>{b}</li>)}</ul>
                        </div>
                        <div className="pondyhcura-treatment-cta">
                          <Link className="pondyhcura-treatment-learnmore" to={serviceLearnMoreUrl(advancedServices[activeService].id)}>Know More</Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pondyhcura-stats-banner">
        <div className="pondyhcura-stat"><h3>10,000+</h3><p>Happy Patients</p></div>
        <div className="pondyhcura-stat"><h3>15+</h3><p>Years Experience</p></div>
        <div className="pondyhcura-stat"><h3>30+</h3><p>Good Doctors</p></div>
        <div className="pondyhcura-stat"><h3>5</h3><p>Chennai Locations</p></div>
      </section>

      <section id="locations" className="pondyhcura-locations">
        <div className="pondyhcura-section-header">
          <h2>Our Clinic Locations</h2>
          <p>Find the nearest H-Cura clinic for your health needs</p>
        </div>
        {/* <div className="pondyhcura-location-tabs">
          <Link to="/multispecialty-clinic-in-kodambakkam-chennai" className={`pondyhcura-location-tab active`}><FaMapMarkerAlt /> Kodambakkam</Link>
        </div> */}
        <div className="pondyhcura-location-details">
          <div className="pondyhcura-location-card">
            <div className="pondyhcura-location-header">
              <h3>{locations.kodambakkam.name} Clinic</h3>
              <span className="pondyhcura-specialty-tag">{locations.kodambakkam.specialties}</span>
            </div>
            <div className="pondyhcura-location-grid">
              <div className="pondyhcura-location-info">
                <div className="pondyhcura-info-item">
                  <FaMapMarkerAlt />
                  <div>
                    <h4>Address</h4>
                    <p>{locations.kodambakkam.address}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaPhone />
                  <div>
                    <h4>Phone</h4>
                    <p>{locations.kodambakkam.phone}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaClock />
                  <div>
                    <h4>Open Hours</h4>
                    <p>{locations.kodambakkam.hours}</p>
                  </div>
                </div>
              </div>
              <div className="pondyhcura-popular-services">
                <h4>Popular Treatments</h4>
                <ul>{locations.kodambakkam.popularServices.map((s, i) => <li key={i}><FaCheckCircle /> {s}</li>)}</ul>
                <a href={locations.kodambakkam.mapUrl} target="_blank" rel="noopener noreferrer" className="pondyhcura-map-link">See on Map <FaArrowRight /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="pondyhcura-testimonials">
        <div className="pondyhcura-section-header">
          <h2>What Our Chennai Patients Say</h2>
          <p>Hear from patients across Kodambakkam and nearby areas who have transformed their health at H-Cura:</p>
        </div>
        <div className="pondyhcura-testimonials-grid">
          {testimonials.map((t, index) => (
            <motion.div className="pondyhcura-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <div className="pondyhcura-testimonial-rating">{[...Array(5)].map((_, i) => <FaStar key={i} className="pondyhcura-star-filled" />)}</div>
              <p className="pondyhcura-testimonial-text">"{t.text}"</p>
              <div className="pondyhcura-testimonial-author">
                <h4>{t.name}</h4>
                <p>{t.location} • {t.service}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="appointment" className="pondyhcura-appointment" style={{ position: "relative", overflow: "hidden", color: "#fff" }}>
        <video autoPlay muted loop playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -2 }}><source src={hcuraHeroVideo2} type="video/mp4" /></video>
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))", zIndex: -1 }}></div>
        <div className="pondyhcura-appointment-content">
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>Book Appointment at H-Cura Kodambakkam Today</motion.h2>
          <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>Take the first step toward healthier skin, stronger hair, better wellness, and a confident smile. Schedule your visit today.</motion.p>
          <div className="pondyhcura-contact-options">
            <div className="pondyhcura-contact-option"><FaPhone /> <span>+91 99646 88333</span></div>
            <div className="pondyhcura-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">www.h-cura.com</a></div>
          </div>
          <div className="pondyhcura-appointment-buttons">
            <Link to="/bookconsultation" className="pondyhcura-primary-button">Book Appointment</Link>
            <a href="https://wa.me/919964688333" className="pondyhcura-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
          </div>
        </div>
      </section>

      {/* Modal viewer for detailed view with scrolling */}
      {valasaravakamchennaiBaModalOpen && (
        <div className="pondyhcura-ba-modal" role="dialog" aria-modal="true">
          <div className="pondyhcura-ba-modal-backdrop" onClick={closeTambaramBaModal} />
          <div className="pondyhcura-ba-modal-panel">
            <header className="pondyhcura-ba-modal-header">
              <h3>Treatment Results - H-Cura Kodambakkam</h3>
              <button className="pondyhcura-ba-modal-close" onClick={closeTambaramBaModal}>×</button>
            </header>
            <div className="pondyhcura-ba-modal-body">
              <div className="pondyhcura-ba-scrollable-container">
                <div className="pondyhcura-ba-scroll-track" id="scrollTrack">
                  <div className="pondyhcura-ba-scrollable-grid" id="scrollableGrid">
                    {valasaravakamchennaiBaModalItems.map((item, index) => (
                      <div key={item.id} className="pondyhcura-ba-scrollable-card">
                        <div className="pondyhcura-ba-scrollable-image-container"><img src={item.combined} alt={item.title} className="pondyhcura-ba-scrollable-image" /></div>
                        <div className="pondyhcura-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="pondyhcura-ba-scrollable-testimonial">"{item.testimonial?.quote || ""}"</p>
                          <div className="pondyhcura-ba-scrollable-author">— {item.testimonial?.author || ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="pondyhcura-ba-scroll-progress"><div className="pondyhcura-ba-progress-bar" id="progressBar"></div></div>
              </div>
              <div className="pondyhcura-ba-enhanced-controls">
                <div className="pondyhcura-ba-nav-buttons">
                  <button className="pondyhcura-ba-nav-btn" id="prevBtn" onClick={() => scrollGallery("prev")}>Previous</button>
                  <button className="pondyhcura-ba-nav-btn" id="nextBtn" onClick={() => scrollGallery("next")}>Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Kodambakkam;
